import React from 'react';

function Quote() {
  return (
    <>
      <div className="divQuote">
        <p className="quotePara">
          Mathematics is not about numbers, equations, computations, or algorithms:
          it is about understanding. - William Paul Thurston
        </p>
      </div>
    </>
  );
}

export default Quote;
